import { useQuery } from '@tanstack/react-query';

import { MotifMefDto, ReferentielControllerApi } from 'lib_api/lib/api/gen';

import { useApi } from 'hooks/ApiStoreContext';
import { backAlertMessage } from 'hooks/utils/backAlertMessage';

export async function fetchMotifMefList(
  refController: ReferentielControllerApi,
): Promise<MotifMefDto[]> {
  return refController.getValidMotifMefUsingGET().then(response => {
    return response.referenceDtoList.sort((a, b) =>
      a.motifMef.localeCompare(b.motifMef),
    );
  });
}

export function fetchMotifMefById(
  refController: ReferentielControllerApi,
  idMotifMef: string,
): Promise<MotifMefDto> {
  return refController.getMotifMefByIdUsingGET(idMotifMef);
}

export function useFetchMotifMefByNatureLibelleCourt(
  natureLibelleCourt?: string,
) {
  const { ReferentielControllerApi: refController } = useApi();

  async function fetchMotifMefByNatureLibelleCourt(): Promise<MotifMefDto[]> {
    const response = await refController
      .searchAllMotifMefUsingSpecsUsingGET({
        filters: {
          natureLibelleCourt,
        },
        sorts: {
          libelle: true,
        },
      })
      .catch((error: Response) => {
        void backAlertMessage(error);
        return { results: { referenceDtoList: [] } };
      });
    return response.results.referenceDtoList;
  }

  const res = useQuery({
    queryKey: ['motifMefByNature', natureLibelleCourt],
    queryFn: fetchMotifMefByNatureLibelleCourt,
  });

  return res.data || [];
}
